import { render, staticRenderFns } from "./star-data.vue?vue&type=template&id=18394d96"
import script from "./star-data.vue?vue&type=script&lang=js"
export * from "./star-data.vue?vue&type=script&lang=js"
import style0 from "./star-data.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports